import storage from 'redux-persist/lib/storage';

import { STORE_KEY } from '@~/constants/keys';

const persistConfig = {
  key: STORE_KEY,
  storage,
  whitelist: [
    'feelCheck',
    'ptmSlideEvent',
    'talkMeter',
    'ptmFeedback',
    'liveClassConfig',
    'perfectHits',
  ],
};

export { persistConfig };
